import { useCallback, useMemo } from "react";
import { apiAds } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";
import type { OnlyFansSource } from "@/common/api/services/types";

export const useOnlyFansCreators = (source: OnlyFansSource, count = 3, canRunRequest = true) => {
  const fetchAdCreators = useCallback(() => apiAds.getAdsCreators({ source, count }), []);
  const { data, isLoading } = useFetch(fetchAdCreators, canRunRequest);
  const adCreators = useMemo(() => (data?.ads || []).slice(0, count), [data, count]);

  return {
    adCreators,
    isLoading,
  };
};
